//main
import ContentFormatXC from "../content/webc/content-format-xc";

import WebbDividerSmall from "../content/webb/webb-divider-sm";
import HeaderSectionDark from "../content/webb/head-section-dark";

import TransfersListModule from "../content/transfers/transfer-list";

import { UserForm } from "../services/srvc-utilities";

export default function Transfers() {

  return (
  <>
    <ContentFormatXC 
      head='Transfers'
      link={`/${UserForm()}/home`}
      form= 'small'
      data= {
        <>
          <WebbDividerSmall />
          <TransfersListModule />

        </>
      } 
    />
  </>
  )
}